import { FC, ReactNode } from 'react';
import cls from './dashboard-state-card.module.scss';
import { Card } from 'shared/ui/card/card';

interface DashboardStateCardProps {
  title: string;
  description: string;
  children?: ReactNode;
  className?: string;
}

export const DashboardStateCard: FC<DashboardStateCardProps> = ({
  title,
  description,
  children,
  className,
}) => {
  return (
    <Card className={`${cls.stateCard}${className ? ` ${className}` : ''}`}>
      <div className={cls.content}>
        <div className={cls.textBlock}>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        {children ? <div className={cls.actions}>{children}</div> : null}
      </div>
    </Card>
  );
};
